import KitchenEquipmentItem from "../../components/KitchenEquipmentItem/KitchenEquipmentItem";

import { KITCHEN_EQUIPMENTS_DATA } from "../../constants/KitchenEquipments.constant";

const KitchenEquipments = () => {
  const KitchenEquipmentsData = KITCHEN_EQUIPMENTS_DATA;
  return (
    <div className="app-kitchenEquipments" id="kitchen-equipments">
      <div className="app-kitchenEquipments__headContainer">
        <h2 className="app-kitchenEquipments__headText">
          Steam Line Equipment And Fabrication Work
        </h2>
        <p className="app-kitchenEquipments__paraText">
          These products are widely used in restaurants, hotels, canteens and
          food joints. We provide all our products in various sizes, shapes and
          designs at market leading price. We also provide customization
          facility to customers as per their requirement and specification.
        </p>
      </div>
      <div>
        {KitchenEquipmentsData.map((itemData: any, itemIndex: any) => {
          return (
            <KitchenEquipmentItem
              key={`KitchenEquipmentItem-${itemIndex}`}
              itemData={itemData}
            />
          );
        })}
      </div>
    </div>
  );
};

export default KitchenEquipments;
